export const ct_sid_name = 'ct_sid'
export const ct_vid_name = 'ct_vid'
export const CT_COUNTRY_COOKIE = process.env.CT_COUNTRY_COOKIE || 'ct-country'
export const CT_LANG_COOKIE = process.env.CT_LANG_COOKIE || 'ct-language'
export const CT_CURRENCY_COOKIE = process.env.CT_CURRENCY_COOKIE || 'ct-currency'
